import { render, staticRenderFns } from "./TrailSystemNavbar.vue?vue&type=template&id=545e420c&scoped=true&"
import script from "./TrailSystemNavbar.vue?vue&type=script&lang=js&"
export * from "./TrailSystemNavbar.vue?vue&type=script&lang=js&"
import style0 from "./TrailSystemNavbar.vue?vue&type=style&index=0&id=545e420c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545e420c",
  null
  
)

export default component.exports